module.exports = __webpack_public_path__ + "img/f0a19c2.jpg";